import { render, staticRenderFns } from "./roleEdit.vue?vue&type=template&id=3d8019ca&scoped=true&"
import script from "./roleEdit.vue?vue&type=script&lang=js&"
export * from "./roleEdit.vue?vue&type=script&lang=js&"
import style0 from "./roleEdit.vue?vue&type=style&index=0&id=3d8019ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8019ca",
  null
  
)

export default component.exports